enum HashsumType {
  NONE = 'none',
  MD5 = 'md5',
  SHA1 = 'sha1',
  SHA256 = 'sha256',
  SHA512 = 'sha512',
}

export default HashsumType;
